import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, map, Observable } from 'rxjs';
import { Lesson, LessonDto } from '../models';

@Injectable({
    providedIn: 'root',
})
export class HttpService {
    private httpClient = inject(HttpClient);

    getLesson(id: string): Observable<Lesson> {
        return this.httpClient.get<LessonDto>(`api/v1/library/lessons/${id}`).pipe(
            map((response) => new Lesson(response)),
            catchError((error: HttpErrorResponse) => {
                if (error.status === 403) {
                    throw new Error('no-access');
                }
                throw error;
            }),
        );
    }
}
